import React from "react"
import PropTypes from 'prop-types'
import { Link, StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"

const indexPage = () => (
    <StaticQuery
      query={graphql`
      {
        markdownRemark{
          frontmatter{
            featuredImage{
              childImageSharp {
                fluid(maxWidth: 700) {
                  src
                }
              }
            }
          }
        }
      }
      
      `}
      render={({markdownRemark}) => (
        <section className="section">
        <div className="container">
        <h1 class="title">Um okkur</h1>
        <div class="columns is-multiline">
            <div className="column is-half">
                <div className="text-column">
                    <p class="about-us-paragraph">Strendingur ehf. verkfræðiþjónusta er einkahlutafélag stofnað 26. janúar 1995.</p>
                    <p class="about-us-paragraph">Strendingur fæst við hönnun, ráðgjafaþjónustu á byggingarsviði, stjórnun verkefna, rannsóknir o.fl.</p>
                    <p class="about-us-paragraph">Frá stofnun hefur Strendingur tekið að sér verkefni á nær öllum sviðum byggingarverkfræði svo sem hönnun, umsjón og eftirlit, innkauparáðgjöf, samningagerð, útboð og framkvæmdaráðgjöf.</p>
                    <p class="about-us-paragraph">Starfsfólk Strendings býr yfir víðtækri þekkingu og reynslu af mannvirkjagerð. Flestir starfsmenn fyrirtækisins hafa meira en 15 ára starfsreynslu.</p>
                    <p class="about-us-paragraph">Í Strendingi er unnið samkvæmt vottuðu gæðakerfi i samræmi við ISO 9001 gæðastaðalinn.</p>
                    <p class="about-us-paragraph">Fyrirtækið er til húsa í 256m² húsnæði við Fjarðargötu 13-15 í Hafnarfirði.</p>
                </div>
            </div> 
            <div class="column is-half">
                <img src={markdownRemark.frontmatter.featuredImage.childImageSharp.fluid.src} alt="Placeholder image"></img>
            </div>
        </div>
            
        </div>    
        </section>
      )}
    />
  )
  
  export default indexPage



/*
const AboutUs = ({ siteTitle }) => (
    <section className="section">
    <div className="container">
    <h1 class="title">Um okkur</h1>
    <div class="columns is-multiline">
        <div className="column is-half">
            <div className="text-column">
                <p class="about-us-paragraph">Strendingur ehf. verkfræðiþjónusta er einkahlutafélag stofnað 26. janúar 1995.</p>
                <p class="about-us-paragraph">Strendingur fæst við hönnun, ráðgjafaþjónustu á byggingarsviði, stjórnun verkefna, rannsóknir o.fl.</p>
                <p class="about-us-paragraph">Frá stofnun hefur Strendingur tekið að sér verkefni á nær öllum sviðum byggingarverkfræði svo sem hönnun, umsjón og eftirlit, innkauparáðgjöf, samningagerð, útboð og framkvæmdaráðgjöf.</p>
                <p class="about-us-paragraph">Starfsfólk Strendings býr yfir víðtækri þekkingu og reynslu af mannvirkjagerð. Flestir starfsmenn fyrirtækisins hafa meira en 15 ára starfsreynslu.</p>
                <p class="about-us-paragraph">Í Strendingi er unnið samkvæmt vottuðu gæðakerfi i samræmi við ISO 9001 gæðastaðalinn.</p>
                <p class="about-us-paragraph">Fyrirtækið er til húsa í 256m² húsnæði við Fjarðargötu 13-15 í Hafnarfirði.</p>
            </div>
        </div> 
        <div class="column is-half">
            <img src="../images/projects/gamathjonusta/forsida_mynd_1.jpg" alt="Placeholder image"></img>
        </div>
    </div>
        
    </div>    
    </section>
)

export default AboutUs
*/